import Api from '../api'
export default ({
  state: {
    inventoryInOutLists: [],
    inventoryInOutStoreLists: [],
    itemStatemnetLists: [],
    inventoryClosingStockLists: [],
    itemDayBookLists: [],
    inventoryClosingStockStoreWiseList: [],
    inventoryClosingStockStoreAndItemWiseLists: [],
    inventoryNegativeStockLists: []
  },
  mutations: {
    INVENTORY_IN_OUT_LIST(state, inventoryInOut) {
      state.inventoryInOutLists = inventoryInOut
    },
    INVENTORY_IN_OUT_STORE_LIST(state, inventoryInOutStore) {
      state.inventoryInOutStoreLists = inventoryInOutStore
    },
    INVENTORY_STOCK_STORE_WISE(state, inventoryClosingStockStoreWise) {
      state.inventoryClosingStockStoreWiseList = inventoryClosingStockStoreWise
    },
    INVENTORY_STOCK_STORE__ITEM_WISE(state, inventoryClosingStockStoreItemWise) {
      state.inventoryClosingStockStoreAndItemWiseLists = inventoryClosingStockStoreItemWise
    },
    INVENTORY_NEGATIVE_STOCK(state, inventoryNegativeStockList) {
      state.inventoryNegativeStockLists = inventoryNegativeStockList
    },
    ITEM_STATEMENT_LIST(state, itemStatement) {
      state.itemStatemnetLists = itemStatement
    },
    ITEM_CLOSING_STOCK(state, itemClosingStock) {
      state.inventoryClosingStockLists = itemClosingStock
    },
    ITEM_DAY_BOOK_LIST(state, itemDayBook) {
      state.itemDayBookLists = itemDayBook
    }
  },
  actions: {
    async loadInventoryInOutReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/inventoryInOutReport/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.fyId + '')
      let responseValue = response.data.data
      commit('INVENTORY_IN_OUT_LIST', responseValue)
      return responseValue
    },
    async loadInventoryInOutStoreWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/inventoryInOutReportStoreWise/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('INVENTORY_IN_OUT_STORE_LIST', responseValue)
      return responseValue
    },
    async loadItemStatementReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/itemStatementReport/' + date.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('ITEM_STATEMENT_LIST', responseValue)
      return responseValue
    },
    async loadItemPurchaseDetailsReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryInReport/purchaseDetailsByItem/' + this.state.organisationid + '/' + this.getters.userId + '/' + this.state.fyId + '/' + date.id + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('ITEM_STATEMENT_LIST', responseValue)
      return responseValue
    },
    async loadItemSalesDetailsReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/salesDetailsByItem/' + this.state.organisationid + '/' + this.getters.userId + '/' + this.state.fyId + '/' + date.id + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('ITEM_STATEMENT_LIST', responseValue)
      return responseValue
    },
    async loadInventoryClosingStock({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/inventoryClosingStock/' + this.state.organisationid + '/' + date.toDate + '/' + this.state.fyId + '')
      let responseValue = response.data.data
      commit('ITEM_CLOSING_STOCK', responseValue)
      return response
    },
    async loadItemDayBook({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/itemDayBook/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('ITEM_DAY_BOOK_LIST', responseValue)
      return responseValue
    },
    async loadInventoryStockStoreWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/inventoryClosingStockStoreWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('INVENTORY_STOCK_STORE_WISE', responseValue)
      return responseValue
    },
    async loadInventoryStockStoreAndItemWise({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/closingStockStoreAndItemWise/' + this.state.organisationid + '/' + this.state.fyId + '')
      let responseValue = response.data.data
      commit('INVENTORY_STOCK_STORE__ITEM_WISE', responseValue)
      return responseValue
    },
    async loadClosingStockForPos({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/inventoryClosingStockForPosReport/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('ITEM_CLOSING_STOCK', responseValue)
      return responseValue
    },
    async negativeClosingStock({ commit }, date) {
      let response = await Api.request('get', '/inventoryStock/negativeClosingStock/' + this.state.organisationid + '/' + this.state.fyId + '')
      let responseValue = response.data.data
      commit('INVENTORY_NEGATIVE_STOCK', responseValue)
      return responseValue
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/inventoryReport.js